import React, { useContext } from 'react';
import {
  ThemeProvider as MuiThemeProvider,
  createMuiTheme,
} from '@material-ui/core/styles';
import { ThemeProvider } from 'styled-components';
import PropTypes from 'prop-types';
import { tenantContext } from './TenantProvider';
import { dapTheme } from './global/DapTheme';

const TenantThemeProvider = ({ children }) => {
  const { tenant } = useContext(tenantContext);

  const themeConfig = tenant
    ? {
        ...dapTheme,
        palette: {
          ...dapTheme.palette,
          primary: {
            main: tenant.settings.primaryColor,
            contrastText: tenant.settings.contrast,
          },
          secondary: {
            main: tenant.settings.secondaryColor,
            contrastText: tenant.settings.contrast,
          },
        },
      }
    : dapTheme;

  const tenantTheme = createMuiTheme(themeConfig);

  return (
    <MuiThemeProvider theme={tenantTheme}>
      <ThemeProvider theme={tenantTheme}>{children}</ThemeProvider>
    </MuiThemeProvider>
  );
};

TenantThemeProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default TenantThemeProvider;
